import { fetchApi } from "../utils/fetchApi";

export function fetchEvstatus({ filter = {}, options = {} }) {
  return fetchApi({ url: `evstatus/${filter.vin}`, filter: {}, options });
}